import { render } from "./DatePickerBody.vue?vue&type=template&id=b0b6f6da&scoped=true"
import script from "./DatePickerBody.vue?vue&type=script&lang=js"
export * from "./DatePickerBody.vue?vue&type=script&lang=js"

import "./DatePickerBody.vue?vue&type=style&index=0&id=b0b6f6da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b6f6da"]])

export default __exports__